import { NgModule }      from '@angular/core';
import { ContentTypeBuilder }     from './content-type-builder';
import { ContentTemplateBuilder } from './content-template-builder';
import DPSManageContent from './dps-manage-content.component';
import { DpsEntitiesModule } from '../dps-entities.module';

@NgModule({
    imports:   [ DpsEntitiesModule ],
    declarations: [ DPSManageContent ],
    exports:      [ DPSManageContent ]
})

export class ContentModule {
    static forRoot() {
        return {
            ngModule: ContentModule,
            providers: [
                ContentTemplateBuilder,
                ContentTypeBuilder
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/content-switcher/content.module.ts